module.exports = __webpack_public_path__ + "static/media/zazus2.0a4dce1f.png";